// @flow

import styled from "styled-components";

const RootComponent = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: ${props => props.theme.header.height};
  background-color: ${props => props.theme.mainBackground}
`;

export default RootComponent;



// WEBPACK FOOTER //
// ./src/components/RootComponent/index.jsx